import config from "../config";
import apiSlice from "./apiSlice";

const exportReportSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        /* ---------- POST: EXPORT REPORT ---------- */
        exportReport: builder.mutation({
            query: ({ dataToUpdate }) => ({
                url: `reports/${process.env.REACT_APP_API_VERSION}/exports${config.REACT_APP_ENV_NAME}`,
                method: "POST",
                body: JSON.stringify(dataToUpdate),
            }),
            invalidatesTags: (_) => ["generateJobId"],
            transformResponse: (response) => {
                return response;
            },
        }),

        /* ---------- GET: EXPORT STATUS ---------- */
        getExportStatus: builder.query({
            query: ({ email }) => ({
                url: `reports/${process.env.REACT_APP_API_VERSION}/exports/status${config.REACT_APP_ENV_NAME}`,
                method: "GET",
                headers: {
                    "x-unum-param-emailaddress": email,
                },
            }),
            invalidatesTags: (_) => ["exportStatus"],
            transformResponse: (response) => {
                return response;
            },
        }),
    }),
});
export const {
    useExportReportMutation,
    useGetExportStatusQuery,
    useLazyGetExportStatusQuery,
} = exportReportSlice;
